import * as actions from '../utils/Constants';
import { apiGet, apiDeleteWithBodyAndThen, apiPostAndThen, apiRequest, Methods } from '../utils/Api';

export const userModuleLoaded = () => {
    return {
        type: actions.USER_MODULE_LOADED
    }
}

export const clearUser = () => {
    return { type: actions.CLEAR_USER };
}

export const createUser = (credentials) => {
 
    return {
        type: actions.SAVE_USER,
        payload: fetch(process.env.REACT_APP_API_HOST + `api/user/new`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(credentials),
        }).then(res => {
            return res.json();
        }).catch(error => {
            return Promise.reject(error);
        })
    }
}

export const getUser = (id) => {
    return {
        type: 'GET_USER',
        payload: fetch(process.env.REACT_APP_API_HOST + `api/user/${id}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        }).then(res => {
            return res.json();
        })
    }
}

export const updatePersonName = (name) => {
    return {
        type: 'UPDATE_USER_PERSON_NAME',
        payload: name
    }
}

export const updatePersonPhone = (personPhone, index) => {
    return {
        type: 'UPDATE_USER_PERSON_PHONE',
        payload: { personPhone, index }
    }
}

export const updateUserEmail = (email) => {

    return {
        type: 'UPDATE_USER_EMAIL',
        payload: email
    }
}

export const updateUserRole = (role) => {

    return {
        type: 'UPDATE_USER_ROLE',
        payload: role
    }
}

export const updateUserDailyRate = (rate) => {

    return {
        type: 'UPDATE_USER_DAILY_RATE',
        payload: rate
    }
}

export const addPersonPhone = () => {
    return {
        type: 'ADD_USER_PERSON_PHONE'
    }
}

export const deletePersonPhone = (index) => {
    return {
        type: 'DELETE_USER_PERSON_PHONE',
        payload: index
    }
}

export const saveUser = (user) => {
      
    return {
        type: 'SAVE_USER',
        payload: fetch(process.env.REACT_APP_API_HOST + `api/user/${user.id}`, {
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(user),
        }).then(res => {
            return res.json();
        }).catch(error => {
            return Promise.reject(error);
        })
    }
}

export const updatePersonAddress = (index, type, address) => {
    return {
        type: 'UPDATE_USER_PERSON_ADDRESS',
        payload: { index, type, address }
    }
}

export const addUserClaim = (claim) => {
    return {
        type: actions.ADD_USER_CLAIM,
        payload: claim
    }
}

export const removeUserClaim = (claim) => {
    return {
        type: actions.REMOVE_USER_CLAIM,
        payload: claim
    }
}

export const addPersonCourt = (courtId) => {
    return {
        type: actions.ADD_USER_PERSON_COURT,
        payload: courtId
    }
}

export const removePersonCourt = (courtId) => {
    return {
        type: actions.REMOVE_USER_PERSON_COURT,
        payload: courtId
    }
}

export const updatePersonPhoto = (photo) => {
    return {
        type: actions.UPDATE_USER_PERSON_PHOTO,
        payload: photo
    }
}

export const updatePersonBio = (bio) => {
    return {
        type: actions.UPDATE_USER_PERSON_BIO,
        payload: bio
    }
}

export const addUserCourtType = (courtType) => {
    return {
        type: actions.ADD_USER_COURTTYPE,
        payload: courtType
    }
}

export const removeUserCourtType = (courtType) => {
    return {
        type: actions.REMOVE_USER_COURTTYPE,
        payload: courtType
    }
}

export const addUserRole = (userRole) => {
    return {
        type: actions.ADD_USER_ROLE,
        payload: userRole
    }
}

export const removeUserRole = (userRole) => {
    return {
        type: actions.REMOVE_USER_ROLE,
        payload: userRole
    }
}

export const addUserDiscipline = (discipline) => {
    return {
        type: actions.ADD_USER_DISCIPLINE,
        payload: discipline
    }
}

export const removeUserDiscipline = (discipline) => {
    return {
        type: actions.REMOVE_USER_DISCIPLINE,
        payload: discipline
    }
}

const getPersonJournalApi = (personId) => apiGet(`${process.env.REACT_APP_API_HOST}api/person/${personId}/journal`)

export const savePersonJournalEntry = (personId, journalEntry) => ({
    type: actions.ADD_UPDATE_PERSON_JOUNALENTRY,
    payload: apiPostAndThen(`${process.env.REACT_APP_API_HOST}api/person/journal`, journalEntry, () => getPersonJournalApi(personId))
});

export const getPersonJournal = (personId) => {
    return dispatch => dispatch({
        type: actions.GET_PERSON_JOURNAL,
        payload: apiRequest(`${process.env.REACT_APP_API_HOST}api/person/${personId}/journal`, Methods.get, null, dispatch)
    });
};

export const deletePersonJournalEntries = (personId, ids) => ({
    type: actions.DELETE_PERSON_JOUNALENTRIES,
    payload: apiDeleteWithBodyAndThen(`${process.env.REACT_APP_API_HOST}api/person/journal`, ids, () => getPersonJournalApi(personId))
});

export const setPersonActiveStartDate = (activeStartDate) => ({
    type: actions.UPDATE_PERSON_ACTIVESTARTDATE,
    payload: activeStartDate
});

export const setPersonActiveEndDate = (activeEndDate) => ({
    type: actions.UPDATE_PERSON_ACTIVEENDDATE,
    payload: activeEndDate
});

export const setUserActiveStatus = (isActive) => ({
    type: actions.SET_USER_ACTIVESTATUS,
    payload: isActive
});